export default __webpack_public_path__ + "static/media/complementary--motorcycles--g3.1c3e0e2b.png";